import { Component, OnInit } from '@angular/core';
import { AutoLogoutService } from './services/auto-logout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'happyhr-fe-kiosk';

  constructor(private autoLogoutService: AutoLogoutService) {}

  ngOnInit(): void {
    this.autoLogoutService.initListener();
  }
}
